<div class="flex flex-col">
  <div class="flex flex-row w-[100vw] h-[15vh] baselayout-padding-h bg-cyan-700">
    <div id="header-button-row">
      <p-button [severity]="setButtonState('dashboard')" routerLink="./dashboard">
        <span class="!text-[16px]">{{'Dashboard'|translate}}</span>
      </p-button>
      <p-button [severity]="setButtonState('customers')" routerLink="./customers">
        <span class="!text-[16px]">{{'Customers'|translate}}</span>
      </p-button>
      <p-button [severity]="setButtonState('settings')" routerLink="./settings">
        <span class="material-icons !text-[23.8px]">settings</span>
      </p-button>
      <p-button [severity]="setButtonState('settings')" (click)="openFeedbackWidget()">
        <span class="material-icons !text-[23.8px]">bug_report</span>
      </p-button>
    </div>
    <div class="self-end py-[2vh] text-5xl tracking-widest">
      @if (!shouldShowBreadcrumbs()) {
        {{ getTitle() }}
      }
      @if (shouldShowBreadcrumbs()) {
        <app-breadcrumbs [breadcrumbItems]="breadcrumbItems"></app-breadcrumbs>
      }
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
